import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { addDesignation, } from "../../Redux/Config/Action";
import { getDesignation } from "../../Redux/NewHire/Action";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import NewDataTable from "../DataTable/NewDataTable";

const Designation = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const { desiglist } = useSelector((store) => store.newHireData);
    const [show, setShow] = useState(false);

    const [designationData, setDesignationData] = useState({
        designationId: "",
        designationName: "",
        actionType: "INSERT"
    });



    useEffect(() => {
        dispatch(getDesignation(token));
    }, [dispatch, token, loginId]);

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Designation Name",
            selector: (row) => row?.designationName || "-",
            sortable: true,
            align: "center",
        },

    ];


    const clearLeaveInputFields = () => {
        setDesignationData({
            designationId: "",
            designationName: "",
            actionType: "INSERT"
        });
    };

    const handleClose = () => {
        clearLeaveInputFields();
        setShow(false);
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setDesignationData((prevData) => {
            let updatedData = {
                ...prevData,
                [id]: value,
            };
            return updatedData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(addDesignation(designationData, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        dispatch(getDesignation(token));
                        setShow(false);
                        clearLeaveInputFields();
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Something went wrong. Please try again later.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }
    };


    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="card3">
                        <div className="card-body">
                            <NewDataTable
                                columns={columns}
                                data={desiglist || []}
                                tableName="DESIGNATIONS"
                                totalRecord={desiglist?.length ?? 0}
                            />
                            <div className="text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary fw-bold mt-3"
                                    onClick={() => setShow(true)}
                                >
                                    ADD
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{`${designationData.actionType === "INSERT" ? "Add" : "Update"} Designation Data`}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row mb-3">
                            
                                    <div className="col-md-12">
                                        <label htmlFor="leaveCode" className="form-label">
                                            Designation Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="designationName"
                                            className="form-control"
                                            name="designationName"
                                            value={designationData.designationName}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            required
                                        />
                                    </div>

                                </div>
                                <div className="text-center">
                                    <button type="submit" className={`btn ${designationData.actionType === "INSERT" ? "btn-success" : "btn-warning"} mt-3`}>
                                        {`${designationData.actionType === "INSERT" ? "SUBMIT" : "UPDATE"}`}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default Designation;